<template>
  <div class="foot-notes">
    <span>v{{ config.app_version }}</span>
    <span class="block">{{ config.footer.prefix }}</span>
    <span><CodeOutlined /> + <HeartOutlined /></span>
    <span class="block">
      Copyright © {{ new Date().getFullYear() }}, {{ config.company.name }}. All rights reserved.
      <router-link class="link-button" to="/terms"><u>terms</u></router-link>
      <router-link class="link-button" to="/privacy"
        ><u>privacy</u></router-link
      >
    </span>
  </div>
</template>
<script setup lang="ts">
import { get_config } from '@/config'

const config = get_config()

import { CodeOutlined, HeartOutlined } from '@ant-design/icons-vue'
</script>
<style scoped>
.foot-notes {
  display: flex;
  width: 100%;
  color: var(--color-footer-text);
  font-size: 12px;
  justify-content: center;
}
.block {
  padding: 0 10px;
}
.footer-links {
  font-size: 12px;
  color: var(--color-footer-text);
}
.link-button {
  font-size: 12px;
  padding: 0 4px;
  /* margin-bottom: 20px; */
  color: var(--color-footer-text);
}
</style>
